import { render, staticRenderFns } from "./MultipleChoiceQ.vue?vue&type=template&id=3e3aa3d9&scoped=true&"
import script from "./MultipleChoiceQ.vue?vue&type=script&lang=js&"
export * from "./MultipleChoiceQ.vue?vue&type=script&lang=js&"
import style0 from "./MultipleChoiceQ.vue?vue&type=style&index=0&id=3e3aa3d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3aa3d9",
  null
  
)

export default component.exports